import { User } from './User'
import { SyncStatus } from '../apps/professional-app/fa/MeetingSummary/ExternalUpdates/models'
import { IntegrationServiceId } from '../common/integrations'

export type MeetingNoteFormat = 'text' | 'rich_text'

export interface MeetingNote {
  id: string
  content: string
  format: MeetingNoteFormat
}

export enum CommentRelationType {
  AI_RESULT = 'aiResult',
  COMMENT = 'comment',
}

export interface CommentMetadata {
  quote: string
  basePath: string
  path: string
  markId: string
  deleted?: boolean
}

export interface Comment {
  id: string
  comment: string
  createdAt: string
  updatedAt: string
  relationId: string
  relationType: CommentRelationType
  relationMetadata: string
  metadata: CommentMetadata
  user?: User
}

export interface NewComment {
  aiResultId: string
  basePath: string
  path: string
  markId: string
  quote: string
}

export enum TaskStatus {
  OPEN = 'open',
  CLOSED = 'closed',
}

export interface ResolvedIdentity {
  type: string
  id: string
  user?: User
}

interface BaseTask {
  id: string
  accountId: string
  task: string
  description?: string
  assignedTo?: ResolvedIdentity
  relatedTo?: ResolvedIdentity
  status: string
  syncStatus: SyncStatus[]
  priority?: string
  metadata?: { [key: string]: string }
}

interface MeetingTask extends BaseTask {
  type: 'meeting'
  roomId: string
  sessionId: string
}

interface EmailTask extends BaseTask {
  type: 'email'
  emailConnector: string
  threadId: string
  emailId: string
}

export type Task = MeetingTask | EmailTask

interface BaseContactChange {
  id: string
  accountId: string
  userId: string
  serviceId: string
  externalId: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  previousContactValues: { [key: string]: any }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  contactValues: { [key: string]: any }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  contactSchema: { [key: string]: any }
  createdAt: string
  updatedAt: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metadata?: { [key: string]: any }
  syncStatus?: SyncStatus[]
}

interface MeetingContactChange extends BaseContactChange {
  type: 'meeting'
  roomId: string
  sessionId: string
}

interface EmailContactChange extends BaseContactChange {
  type: 'email'
  emailConnector: string
  threadId: string
}

export type ContactChange = MeetingContactChange | EmailContactChange

export interface EntityChange {
  id: string
  accountId: string
  type: 'meeting'
  userId: string
  serviceId: IntegrationServiceId
  objectName: string
  externalId?: string | null
  roomId: string
  sessionId: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  previousObjectValues: { [key: string]: any }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  objectValues: { [key: string]: any }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  objectSchema: { [key: string]: any }
  createdAt: string
  updatedAt: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metadata?: { [key: string]: any }
  syncStatus?: SyncStatus[]
}
